export default __webpack_public_path__ + "roboto-v27-latin-regular.4f862c8ba4ed785461ee30cf79232437.svg";